import { render } from "./addproduct.vue?vue&type=template&id=0ebc6fc5"
import script from "./addproduct.vue?vue&type=script&lang=js"
export * from "./addproduct.vue?vue&type=script&lang=js"

import "./addproduct.vue?vue&type=style&index=0&id=0ebc6fc5&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__